import React, { Component, ReactElement } from 'react';

import { LoaderAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { bool, number, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames } from '@philips-emr/tws-utils';

import './loader.scss';

export interface LoaderProps {
  centered: boolean;
  className: string;
  size: number;
}

@AwesomeComponent({ type: ComponentType.FEEDBACK, api: LoaderAPI })
class Loader extends Component<LoaderProps> {
  static propTypes = {
    centered: bool,
    className: string,
    size: number,
  };

  static defaultProps = {
    size: 32,
    centered: false,
    className: '',
  };

  render(): ReactElement {
    const { centered, className, size } = this.props;

    const style = {
      width: `${size}px`,
      height: `${size}px`,
    };

    const classes = classNames({
      'c-loader': true,
      'o-loader': centered,
      [className]: Boolean(className),
    });

    return (
      <div className={classes} >
        <div className="c-loader__circle" x-contrast="bd" style={style} />
      </div>
    );
  }
}

export default Loader;
